import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'

import { Button } from '@blade/ui-kit'

import { reatomBackOfficeUserActivityToggleAction } from '../atoms/reatom-back-office-user-activity-toggle-action'

import type { BackOfficeUser } from '@root/entities/back-office'

interface BackOfficeUsersActivityToggleButtonProps {
  backOfficeUser: BackOfficeUser.BackOfficeUser
}

export const BackOfficeUsersActivityToggleButton = (
  props: BackOfficeUsersActivityToggleButtonProps,
) => {
  const model = useMemo(
    () =>
      // eslint-disable-next-line @reatom/unit-naming-rule
      reatomBackOfficeUserActivityToggleAction({
        backOfficeUser: props.backOfficeUser,
      }),
    [props.backOfficeUser],
  )
  const [blocked] = useAtom(props.backOfficeUser.blocked)
  const [nextAction] = useAtom(model.nexActionAtom)
  const [toggleRequestState] = useAtom(model.toggleRequestAtom)
  const toggle = useAction(model.toggleAction)

  return (
    <Button
      onClick={() => toggle()}
      size="xxs"
      disabled={toggleRequestState.loading}
      color={blocked ? 'upAccent' : 'downAccent'}
      busy={toggleRequestState.loading}
      radius="rounded"
      variant="ghost"
      type="button"
    >
      {nextAction}
    </Button>
  )
}
